import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Patch list filter query params with replace navigation.
 * Pass a mutator that edits a copy of current params.
 */
export function useListUrlParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const patchParams = useCallback(
    (mutate: (params: URLSearchParams) => void) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          mutate(next);
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  /** Replace entire query string (saved views — plan/35 C). */
  const replaceAllParams = useCallback(
    (qs: string) => {
      setSearchParams(new URLSearchParams(qs), { replace: true });
    },
    [setSearchParams],
  );

  return { searchParams, patchParams, replaceAllParams } as const;
}
